import React from 'react';
import { Trans } from 'lingui-react';
import { connect } from 'react-redux';

import PropTypes from 'utils/prop-types';

import LoginPage from '../LoginPage';
import { redirectToLogin } from '../api';
import { currentTenantSelector } from '../redux/selectors';

import messages from './messages';

export function PortunusLogin({ tenant }) {
  // redirect to Portunus for the login page
  redirectToLogin(tenant);

  return (
    <LoginPage>
      <p><Trans id={messages.redirect} /></p>
    </LoginPage>
  );
}

PortunusLogin.propTypes = {
  tenant: PropTypes.string.isRequired,
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    tenant: currentTenantSelector(state),
  };
}

export default connect(mapStateToProps)(PortunusLogin);



// WEBPACK FOOTER //
// ./features/authentication/PortunusLogin/index.js